module.exports = __webpack_public_path__ + "static/Tiffany-200c88780872aac440d627cef0133481.png";